export const carryOf = (carries, root) => (carries[root] ??= { start: 0, perDay: 0, days: 0, booked: 0 });
const carried = (carry) => carry.start + carry.perDay * carry.days;
// Halves round away from zero, so ties favour neither side.
export const roundHalfAway = (value) => Math.sign(value) * Math.round(Math.abs(value));
// Adds owed interest (negative) to the stream; returns the whole øre now due.
// Per-day rounding books what it is given, already rounded.
export const book = (rounding, carry, exact) => {
    if (rounding === 'perDay') {
        return -exact;
    }
    carry.start = carried(carry) + exact;
    carry.days = 0;
    const booked = roundHalfAway(carry.start);
    const due = carry.booked - booked;
    carry.booked = booked;
    return due;
};
// The rounded running total of an accrual on its days before `day`.
export const bookedBefore = (accrual, day) => roundHalfAway(accrual.origin + accrual.perDay * (day - accrual.originDay));
// Daily accrual over [from, to) of owed (negative) interest, as the days it
// books anything on: each day books what the rounded running total grows by,
// so where the replay stops cannot move interest between days. Null if none.
export const accrueDaily = (rounding, carry, from, to, exactPerDay) => {
    if (rounding === 'perDay') {
        return { from, to, perDay: -exactPerDay };
    }
    if (exactPerDay !== carry.perDay) {
        carry.start = carried(carry);
        carry.perDay = exactPerDay;
        carry.days = 0;
    }
    const accrual = {
        origin: -carry.start,
        originDay: from - carry.days,
        perDay: -exactPerDay,
    };
    carry.days += to - from;
    carry.booked = roundHalfAway(carried(carry));
    const first = bookedBefore(accrual, from);
    const last = bookedBefore(accrual, to);
    if (first === last) {
        return null;
    }
    if (to - from === 1) {
        return { ...accrual, from, to };
    }
    // The days from the first that books anything to the last that does.
    let low = from;
    let high = to - 1;
    while (low < high) {
        const middle = (low + high) >> 1;
        if (bookedBefore(accrual, middle + 1) > first) {
            high = middle;
        }
        else {
            low = middle + 1;
        }
    }
    const start = low;
    high = to;
    while (low < high) {
        const middle = (low + high) >> 1;
        if (bookedBefore(accrual, middle) < last) {
            low = middle + 1;
        }
        else {
            high = middle;
        }
    }
    return { ...accrual, from: start, to: low };
};
//# sourceMappingURL=rounding.js.map